import AdvanceLabelForm from "./advance/advanceLabelForm";
import Artist from "./artist/ArtistForm";
import CashFlow from "./cash-flow/CashFlowForm";
import ChannelVideo from "./channel-video/ChannelVideoForm";
import Channel from "./channel/ChannelForm";
import Contract from "./contract/ContractForm";
import Merch from "./merch/MerchForm";
import Support from "./support/SupportForm";
import MusicProductDigital from "./music-product-digital/MusicProductDigitalForm";
import MusicProductPhysical from "./music-product-physical/MusicProductPhysicalForm";
import Track from "./track/TrackForm";
import Video from "./video/VideoForm";

export default {
  Artist,
  Track,
  MusicProductDigital,
  MusicProductPhysical,
  Merch,
  Channel,
  ChannelVideo,
  AdvanceLabelForm,
  CashFlow,
  Video,
  Contract,
  Support,
};
